































import { Vue, Component, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Action, Mutation, namespace, State } from 'vuex-class';
import Header from './layout/header.vue';
const System = namespace('System');
@Component({
  components: { Header }
})
export default class Main extends Vue {
  @State MENU_INDENT: any;
  @Mutation SWITCH_MENU_INDENT: any;
  @System.State activeTabs: any;
  @System.Mutation setActiveTabs: any;
  @System.Mutation closeOtherTabs: any;
  @System.Mutation closeAllTabs: any;
  @System.Mutation removeActiveTabs: any;
  @Action('getDictList') getDictList: any;
  @Action('getMenuList') getMenuList: any;

  activeKey: string = '';

  get IS_BLANK() {
    let path = this.$route.path;
    let blanks = ['/analyze', '/decision', '/jobs', '/platform', '/task'];
    return blanks.includes(path);
  }

  created() {
    this.getDictList();
    this.getMenuList();
  }

  @Watch('$route')
  onRouteChange() {}

  changeTab(path: string) {
    this.$router.push(path);
  }

  onEdit(targetKey: any, action: any) {
    if (action === 'remove') {
      this.removeActiveTabs(targetKey);
      // if (targetKey === this.activeKey && this.activeTabs.length != 0) this.changeTab(this.activeTabs.pop().fullPath);
    }
  }

  beforeRouteEnter(to: Route, from: Route, next: (vm: any) => void) {
    next((vm: any) => {
      vm.setActiveTabs({ title: to.meta.title, fullPath: to.fullPath, path: to.path, fromPath: from.path });
      vm.activeKey = to.fullPath;
    });
  }

  beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    this.setActiveTabs({ title: to.meta.title, fullPath: to.fullPath, path: to.path, fromPath: from.path });
    this.activeKey = to.fullPath;
    next();
  }

  handleTabMenu(e: any) {
    if (e.key === 'other') {
      this.closeOtherTabs(this.$route.fullPath);
    }
    if (e.key === 'all') {
      this.closeAllTabs();
    }
  }

  rightMenuVisible: boolean = false;
  rightMenu(e: any) {}
}
